import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Chip,
  FormControl,
  InputLabel,
  Box,
  TextField,
  Menu,
  FormHelperText,
} from "@mui/material";
import {
  listBranches,
  listCluster,
  listStates,
  listTerritory,
  listVintage,
  ProductType,
  RelationType,
} from "../services/filterApis";
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

interface Option {
  value: string;
  label: string;
}

interface Filter {
  key: string;
  label: string;
  type: string;
  options?: Option[];
  maxValue? : any;
  isDisabled? : boolean;
}

interface MultiSelectCheckboxGroupProps {
  filters: Filter[];
  selectedValues: Record<string, string[]>; // Stores selected values for each filter
  onChange: (updatedValues: Record<string, string[]>) => void;
 buttons: { label: string; onClick: () => void; disabled?: boolean }[];
  isLoading: boolean [];
  

}

const MultiSelectCheckboxGroup: React.FC<MultiSelectCheckboxGroupProps> = ({
  filters,
  selectedValues,
  onChange,
  buttons,
  isLoading
}) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [stateData, setStateData] = useState<
    { label: string; value: string }[]
  >([]);
  const [territoryData, setTerritoryData] = useState<
    { label: string; value: string }[]
  >([]);
  const [clusterData, setClusterData] = useState<
    { label: string; value: string }[]
  >([]);
  const [branchData, setBranchData] = useState<
    { label: string; value: string }[]
  >([]);
  const [productType, setProductType] = useState<
  { label: string; value: string }[]
  >([]);
  const [relationType, setRelationType] = useState<
  { label: string; value: string }[]
  >([]);
  const [ListVintage, setListVintage] = useState<
  { label: string; value: string }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(true);
  const periodData = [
    {
      "label" : "Daily", 
      "value" : "day"
    },
    {
      "label" : "Weekly", 
      "value" : "week"
    },
    {
      "label" : "Monthly", 
      "value" : "month"
    },
  ]
  const periodWithOutDayData = [
    {
      "label" : "Weekly", 
      "value" : "week"
    },
    {
      "label" : "Monthly", 
      "value" : "month"
    },
  ]

  const displaymodeData = [
    {
      "label" : "Consolidate", 
      "value" : "1"
    },
    {
      "label" : "Comparative", 
      "value" : "2"
    },
  ]

  const HighRiskData = [
    {
      "label" : "Yes", 
      "value" : "1"
    },
    {
      "label" : "No", 
      "value" : "0"
    },
  ]

  const handleChange = (key: string, values: string[]) => {
    onChange({ ...selectedValues, [key]: values });
  };
  const handleScroll = (event: Event) => {
    const menu = document.querySelector(".MuiPaper-root");
    if (menu && menu.contains(event.target as Node)) return;
    setOpenDropdown(null);
  };

  const dataMap: Record<string, any[]> = {
    state: stateData,
    territory: territoryData,
    cluster: clusterData,
    branch: branchData,
    period: periodData,
    periodWithOutDay: periodWithOutDayData,
    highRiskBranch: HighRiskData,
    vintage: ListVintage,
    relationType: productType,
    productType : relationType,
    displaymode: displaymodeData
  };

  const getListData = async () => {
    console.log(selectedValues, "selectedValues")
    try {
      setLoading(true);

      // Call all API functions concurrently
      const [statesRes, territoryRes, clusterRes, branchesRes, ListVintage, productType, relationType  ] =
        await Promise.all([
          listStates(),
          listTerritory(selectedValues?.state || ""),
          listCluster(selectedValues?.state || ""),
          listBranches(selectedValues?.state || "", selectedValues?.highRiskBranch || ""),
          listVintage(),
          ProductType(),
          RelationType(),
        ]);

      // Update states accordingly
      setStateData(
        statesRes?.data?.map((item: any) => ({
          label: item.state_name,
          value: item.state_id,
        })) || []
      );
      setTerritoryData(
        territoryRes?.data?.map((item: any) => ({
          label: item.territory_name,
          value: item.territory_id,
        })) || []
      );
      setClusterData(
        clusterRes?.data?.map((item: any) => ({
          label: item.cluster_name,
          value: item.cluster_id,
        })) || []
      );
      setBranchData(
        branchesRes?.data?.map((item: any) => ({
          label: item.branch_name,
          value: item.branch_id,
        })) || []
      );
      setListVintage(
        ListVintage?.data?.map((item: any) => ({
          label: item.label,
          value: item.value,
        })) || []
      );
      setRelationType(
        relationType?.data?.map((item: any) => ({
          label: item.label,
          value: item.value,
        })) || []
      );
      setProductType(
        productType?.data?.map((item: any) => ({
          label: item.label,
          value: item.value,
        })) || []
      );
    } catch (err) {
      setError("Failed to fetch data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (key: string) => (newDate: Dayjs | null) => {
    onChange({
      ...selectedValues,
      [key]: newDate ? [newDate.format("YYYY-MM-DD")] : [], 
    });
  };


  // const disableButton = (btnLabel: string): boolean => {
  //   if (btnLabel === "Download") {
  //     return isDownloadDisabled;
  //   }

  //   if (btnLabel !== "Apply") return false;
  
  //   const hasPeriod = selectedValues["period"]?.length > 0;
  //   const hasPeriodWithoutDay = selectedValues["periodWithOutDay"]?.length > 0;
  //   const hasFromDate = selectedValues["fromDate"]?.length > 0;
  //   const hasToDate = selectedValues["toDate"]?.length > 0;
  
  //   return !(hasFromDate && hasToDate && (hasPeriod || hasPeriodWithoutDay));
  // };
  const disableButton = (btnLabel: string): boolean => {
    
     // Disable all buttons if any loading state is true
    if (isLoading?.some((loading) => loading)) {
      return true;
    }

    if (btnLabel === "Download") {
      return isDownloadDisabled;
    }
  
    if (btnLabel !== "Apply") return false;
  
    const hasPeriod = selectedValues["period"]?.length > 0;
    const hasPeriodWithoutDay = selectedValues["periodWithOutDay"]?.length > 0;
    const hasFromDate = selectedValues["fromDate"]?.length > 0;
    const hasToDate = selectedValues["toDate"]?.length > 0;
  
    // Enable "Apply" button if filters exist OR if no filters are selected at all
    return hasFromDate || hasToDate || hasPeriod || hasPeriodWithoutDay ? false : false;
  };

  const handleBtnClick = (btn: any) => {
    if (btn.label === "Apply") {
      setIsDownloadDisabled(false);
    }
    btn.onClick(); 
  }


  useEffect(() => {
    if (openDropdown) {
      window.addEventListener("scroll", handleScroll, true);
    } else {
      window.removeEventListener("scroll", handleScroll, true);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [openDropdown]);

  useEffect(() => {
    getListData();
  }, [selectedValues.state]);

  useEffect(() => {
    if (selectedValues.highRiskBranch) {
      listBranches(selectedValues?.state || "", selectedValues?.highRiskBranch || "").then((branchesRes) => {
      });
    }
  }, [selectedValues.highRiskBranch]);

  useEffect(() => {
    setIsDownloadDisabled(true); // Disable the button whenever selectedValues changes
  }, [selectedValues]); // Runs whenever selectedValues updates

  return (
    <div className="container mt-3">
      <div className="row justify-content-between">
        <Box display="flex" flexDirection="row" gap={2} flexWrap="wrap">
          {filters.map((filter) => (
            <div>
              {filter.type === "select" && (
                <FormControl key={filter.key} sx={{ width: 200 }}>
                  <InputLabel>{filter.label}</InputLabel>

                <Select
                  multiple
                  value={selectedValues[filter.key] || []}
                  disabled={filter.isDisabled}
                  // onChange={(event) =>
                  //   onChange({
                  //     ...selectedValues,
                  //     [filter.key]: event.target.value as string[],
                  //   })
                  // }

                  onChange={(event) => {
                    const value = event.target.value as string[];
                    const allOptions = dataMap[filter.key]?.map((opt) => opt.value) || [];
                
                    if (value.includes("all")) {
                      onChange({
                        ...selectedValues,
                        [filter.key]: selectedValues[filter.key]?.length === allOptions.length ? [] : allOptions, // Toggle Select All
                      });
                    } else {
                      onChange({
                        ...selectedValues,
                        [filter.key]: value,
                      });
                    }
                  }}
                  input={<OutlinedInput label={filter.label} />}
                  open={openDropdown === filter.key}
                  onOpen={() => setOpenDropdown(filter.key)}
                  onClose={() => setOpenDropdown(null)}
                  MenuProps={{
                    PaperProps: { sx: { maxHeight: 200, overflowY: "auto" } },
                  }}
                  sx={{
                    width: 200,
                    height: 40, // Fixed height
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center", // Keeps content vertically centered
                  }}
                  renderValue={(selected) => (
                    <Box
                      // display="flex"
                      flexWrap="nowrap"
                      gap={1}
                      sx={{
                        // minHeight: 40, // Ensures height doesn't change
                        alignItems: "center",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {(selected as string[]).map((val) => (
                        <Chip
                          key={val}
                          label={
                            dataMap[filter.key]?.find((opt) => opt.value === val)
                              ?.label
                          }
                          sx={{
                            maxWidth: 80, // Prevents expansion
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        />
                      ))}
                    </Box>
                  )}
                >

                 {/* Select All Option */}
                <MenuItem value="all">
                  <Checkbox
                    checked={selectedValues[filter.key]?.length === dataMap[filter.key]?.length}
                    indeterminate={
                      selectedValues[filter.key]?.length > 0 &&
                      selectedValues[filter.key]?.length < dataMap[filter.key]?.length
                    }
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>

                  {dataMap[filter.key]?.length > 0 ? (
                    dataMap[filter.key]?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={
                            selectedValues[filter.key]?.includes(option.value) ||
                            false
                          }
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No data available</MenuItem>
                  )}
                </Select>
                </FormControl>
              )}
              {filter.type === "singleSelect" && (
                <FormControl key={filter.key} sx={{ width: 200 }} error={!selectedValues[filter.key] || selectedValues[filter.key].length === 0}>
                  <InputLabel id="demo-simple-select-label">{filter.label}</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    disabled={filter.isDisabled}
                    id="demo-simple-select"
                    value={selectedValues[filter.key] || []}
                    label={filter.label}
                    onChange={(event) =>
                      onChange({
                        ...selectedValues,
                        [filter.key]: event.target.value as string[],
                      })
                    }
                    input={<OutlinedInput label={filter.label} />}
                    open={openDropdown === filter.key}
                    onOpen={() => setOpenDropdown(filter.key)}
                    onClose={() => setOpenDropdown(null)}
                    MenuProps={{
                      PaperProps: { sx: { maxHeight: 200, overflowY: "auto" } },
                    }}
                    sx={{
                      width: 200,
                      height: 40, // Fixed height
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center", // Keeps content vertically centered
                    }}
                  >
                    {dataMap[filter.key]?.length > 0 ? (
                      dataMap[filter.key]?.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No data available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              )}
              {filter.type === "date" && (
                <FormControl key={filter.key} sx={{ width: 200}} >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker 
                      onChange={handleDateChange(filter.key)}
                      value={selectedValues[filter.key] ? dayjs(selectedValues[filter?.key][0]) : dayjs("")}
                      label={filter.label} 
                      closeOnSelect={false} 
                      maxDate={dayjs(filter?.maxValue)}
                      format="DD/MM/YYYY"
                      slotProps={{
                        textField: {
                          sx: {
                            height: 10, // Adjust height as needed
                            '& .MuiInputBase-root': {
                              height: 40, // Ensures input field matches desired height
                            },
                            '& .MuiInputBase-input': {
                              padding: '10px 12px', // Adjusts padding inside input
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              )}
              </div>
          ))}
        </Box>
      </div>
      <div className="d-flex justify-content-end mt-2" role="group" aria-label="Button group">
      {buttons.map((btn, index) => (
        <button key={index} disabled={disableButton(btn.label)} type="button" className="btn btn-sm btn-outline-dark mx-1" onClick={() => handleBtnClick(btn)} >
          {btn.label}
        </button>
      ))}
    </div>
    </div>
  );
};

export default MultiSelectCheckboxGroup;

